
const oneRouter = {
  path: '/',
  component: () => import('@/components/report/home.vue'),
  children: [
    // 概况
    {
      path: '/report/survey',
      name: 'survey',
      component: () => import('@/components/report/gather_survey/report_survey.vue')
    },
    {
      path: '/report/target_survey',
      name: 'target_survey',
      component: () => import('@/components/report/target/survey/index.vue')
    },
    {
      path: '/report/target_analysis',
      name: 'target_analysis',
      component: () => import('@/components/report/target/analysis/index.vue')
    },
    // 销售概况
    {
      path: '/report/operate_survey',
      name: 'operate_survey',
      component: () => import('@/components/report/operate/survey/operate_survey.vue')
    },
    // 销售趋势图
    {
      path: '/report/operate_trend',
      name: 'operate_trend',
      component: () => import('@/components/report/operate/trend/operate_trend.vue')
    },
    // 销售增长
    {
      path: '/report/operate_target_trend',
      name: 'operate_target_trend',
      component: () => import('@/components/report/operate/target/operate_target.vue')
    },
    // 客流分析
    {
      path: '/report/operate_passenger',
      name: 'operate_passenger',
      component: () => import('@/components/report/operate/passenger/operate_passenger.vue')
    },
    // 客单价
    {
      path: '/report/operate_price',
      name: 'operate_price',
      component: () => import('@/components/report/operate/price/operate_price.vue')
    },
    // 预约分析
    {
      path: '/report/operate_appoint',
      name: 'operate_appoint',
      component: () => import('@/components/report/operate/appoint/operate_appoint.vue')
    },
    // 项目分析
    {
      path: '/report/operate_project_analysis',
      name: 'operate_project_analysis',
      component: () => import('@/components/report/operate/project_analysis/operate_pj_analysis.vue')
    },
    // 门店对比
    {
      path: '/report/operate_store',
      name: 'operate_store',
      component: () => import('@/components/report/operate/contrast/operate_store.vue')
    },
    // 开卡概况
    {
      path: '/report/card_survey',
      name: 'card_survey',
      component: () => import('@/components/report/card/survey/card_survey.vue')
    },
    // 开卡趋势
    {
      path: '/report/card_trend',
      name: 'card_trend',
      component: () => import('@/components/report/card/trend/card_trend.vue')
    },
    // 开卡增长
    {
      path: '/report/card_target_trend',
      name: 'card_target_trend',
      component: () => import('@/components/report/card/target/card_target.vue')
    },
     // 卡对比
     {
      path: '/report/card_contrast',
      name: 'card_contrast',
      component: () => import('@/components/report/card/cardcontrast/card_customer.vue')
    },
    // 充值分析
    {
      path: '/report/card_price',
      name: 'card_price',
      component: () => import('@/components/report/card/price/card_price.vue')
    },
    // 渠道来源分析
    {
      path: '/report/card_customer',
      name: 'card_customer',
      component: () => import('@/components/report/card/customer/card_customer.vue')
    },
    // 门店对比
    {
      path: '/report/card_store',
      name: 'card_store',
      component: () => import('@/components/report/card/contrast/card_store.vue')
    },

    
    {
      path: '/report/run_survey',
      name: 'run_survey',
      component: () => import('@/components/report/run/survey/run_survery.vue')
    },
    {
      path: '/report/run_trend',
      name: 'run_trend',
      component: () => import('@/components/report/run/trend/run_trend.vue')
    },
    {
      path: '/report/run_target',
      name: 'run_target',
      component: () => import('@/components/report/run/target/run_target.vue')
    },
    {
      path: '/report/run_server',
      name: 'run_server',
      component: () => import('@/components/report/run/server/run_server.vue')
    },
    {
      path: '/report/run_NPS',
      name: 'run_NPS',
      component: () => import('@/components/report/run/NPS/run_NPS.vue')
    },
    {
      path: '/report/run_clock',
      name: 'run_clock',
      component: () => import('@/components/report/run/clock/run_clock.vue')
    },
    {
      path: '/report/run_reward',
      name: 'run_reward',
      component: () => import('@/components/report/run/reward/run_reward')
    },
    {
      path: '/report/run_need',
      name: 'run_need',
      component: () => import('@/components/report/run/need/run_need.vue')
    },
    {
      path: '/report/run_store',
      name: 'run_store',
      component: () => import('@/components/report/run/contrast/run_store.vue')
    },
    // 单店趋势。【运营】-【销售分析】菜单下的【单店趋势】入口
    {
      path: '/report/single_trend',
      name: 'single_trend',
      component: () => import('@/components/report/operate/single/operate_trend.vue')
    },
    // LE-5997 人群销售趋势。复用销售趋势，新增国际特征筛选（位于单店趋势与销售增长之间）
    // 注意：name 必须等于内容配置的 page.name（crowd_sales_trend），content.vue 以 $route.name === page.name 作为拉数据的开关
    {
      path: '/report/crowd_sales_trend',
      name: 'crowd_sales_trend',
      component: () => import('@/components/report/operate/crowd/operate_trend.vue')
    },
  ]
}

export default oneRouter
